export class PageMovimientos {
    public size:number;
    public totalElements:number;
    public totalPages:number;
    public pageNumber:number;
    constructor() {
        this.size = 6;
        this.pageNumber = 1;
    }
}